import 'bootstrap/dist/css/bootstrap.min.css';
import { EnvService, PackageService } from "namirasoft-core";
import ReactDOM from "react-dom/client";
import TagManager from 'react-gtm-module';
import { BrowserRouter } from "react-router-dom";
import json from "../package.json";
import "./index.css";
import Router from "./Router";

PackageService.MainJson = json;
PackageService.ThisJson = json;

let REACT_APP_GOOGLE_TAGMANAGER_ID = new EnvService("REACT_APP_GOOGLE_TAGMANAGER_ID").getNullString();

if (REACT_APP_GOOGLE_TAGMANAGER_ID)
    TagManager.initialize({
        gtmId: REACT_APP_GOOGLE_TAGMANAGER_ID
    });

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

// base
const REACT_APP_BASE_PATH = process.env.REACT_APP_BASE_PATH;
if (REACT_APP_BASE_PATH)
{
    const baseElement = document.createElement('base');
    baseElement.href = REACT_APP_BASE_PATH + "/";
    const head = document.querySelector('head');
    head?.appendChild(baseElement);
}

root.render(
    <BrowserRouter>
        <Router />
    </BrowserRouter>
);